import { Html, Head, Body, Container, Section, Heading, Text } from '@react-email/components';
import { EmailHeader, EmailFooter } from './components';

interface ResponseHandlingProps {
  contactName: string;
  companyName: string;
  period: string;
  status: 'received' | 'missing_data' | 'complete';
  metricsSummary?: string[];
  missingMetrics?: string[];
}

export const ResponseHandling = ({ contactName, companyName, period, status, metricsSummary = [], missingMetrics = [] }: ResponseHandlingProps) => {
  return (
    <Html>
      <Head />
      <Body
        style={{
          backgroundColor: '#F9FAFB',
          fontFamily: "'Figtree', Arial, sans-serif",
          padding: '32px 0',
        }}
      >
        <Container
          style={{
            backgroundColor: '#FFFFFF',
            borderRadius: '12px',
            border: '1px solid #E5E7EB',
            boxShadow: '0 2px 6px rgba(15,23,42,0.08)',
            padding: '32px',
            maxWidth: '600px',
          }}
        >
          <EmailHeader />

          {status === 'missing_data' && (
            <Section
              style={{
                backgroundColor: '#FEF3C7',
                border: '1px solid #F59E0B',
                borderRadius: '8px',
                padding: '12px 16px',
                marginBottom: '16px',
              }}
            >
              <Text style={{ margin: '0', color: '#92400E', fontSize: '14px', fontWeight: '600' }}>⚠️ Additional Information Needed</Text>
            </Section>
          )}

          <Heading
            style={{
              fontSize: '24px',
              lineHeight: '1.3',
              color: '#174a43',
              margin: '0 0 16px',
            }}
          >
            {status === 'received' && `Received — ${period} metrics for ${companyName}`}
            {status === 'missing_data' && `Additional information needed — ${period} update`}
            {status === 'complete' && `${period} Quarterly Metrics — Complete`}
          </Heading>

          <Text
            style={{
              fontSize: '16px',
              lineHeight: '1.6',
              color: '#111827',
              margin: '0 0 16px',
            }}
          >
            Hi {contactName},
          </Text>

          <Text
            style={{
              fontSize: '16px',
              lineHeight: '1.6',
              color: '#111827',
              margin: '0 0 16px',
            }}
          >
            {status === 'received' && `We received your ${period} update and extracted the following metrics:`}
            {status === 'missing_data' && `Thanks for the ${period} submission for ${companyName}. We still need the items below:`}
            {status === 'complete' && `Your ${period} metrics for ${companyName} are complete and recorded. Thank you for your timely submission!`}
          </Text>

          {(status === 'received' || status === 'missing_data') && (
            <Section
              style={{
                backgroundColor: status === 'missing_data' ? '#FEF3C7' : '#E8F5F3',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '24px',
              }}
            >
              <Text style={{ margin: '0 0 8px', fontWeight: '600', color: '#174a43' }}>{status === 'received' ? 'Extracted Metrics:' : 'Missing Metrics:'}</Text>
              {(status === 'received' ? metricsSummary : missingMetrics).map((metric, index) => (
                <Text key={index} style={{ margin: '4px 0', fontSize: '14px', color: '#111827' }}>
                  • {metric}
                </Text>
              ))}
            </Section>
          )}

          <Text
            style={{
              fontSize: '14px',
              lineHeight: '1.6',
              color: '#4B5563',
              margin: '0 0 32px',
            }}
          >
            {status === 'received' && 'No further action needed. If you see any issues with the metrics, simply reply to this email with the correct information.'}
            {status === 'missing_data' && "Reply with the data or any supporting files, and we'll update the report."}
            {status === 'complete' && "No further action needed. We'll reach out again next quarter."}
          </Text>

          <EmailFooter />
        </Container>
      </Body>
    </Html>
  );
};
